import React from 'react';
import PropTypes from 'prop-types';
import {
  SimpleModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@ami/react/core';
import { Button } from '@ami/react/core';
import { NotificationManager } from 'react-notifications';
import { FormInput } from '@ami/react/core';
import customerApprovalLookupServices from '../../services/customerApprovalLookupServices';
import { CustomerApprovalDocument } from '@ami/react/shared';
import { FormFileUpload } from '@ami/react/core';

export default class CustomerApprovalRejectDocumentsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      newValue: '',
      privateDocument: undefined,
    };
  }

  static propTypes = {
    id: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired,
    onChanged: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
  };

  hide = () => this.props.onHide();

  save = async () => {
    this.setState({ saving: true });
    customerApprovalLookupServices
      .reject(
        this.props.id,
        this.props.fullName,
        this.state.newValue,
        this.state.privateDocument
      )
      .then(async () => {
        await this.props.onChanged();
        this.hide();
        NotificationManager.success('Customer Approval rejected');
      })
      .finally(() => this.setState({ saving: false }));
  };

  updateCustomDocument(updateObject) {
    this.setState({
      privateDocument: new CustomerApprovalDocument({
        fileKey: updateObject.fileKey,
        fileName: updateObject.fileName,
      }),
    });
  }

  render() {
    const { newValue, privateDocument } = this.state;
    const { show } = this.props;
    if (!show) return null;

    return (
      <SimpleModal show={show}>
        <ModalHeader title="Confirm Rejection" />
        <ModalBody>
          <form className="container">
            <div className="row">
              <div className="col">
                <FormInput
                  id="privateNote"
                  label="Please let us know why you are rejecting, and what changes you are requesting."
                  maxLength={500}
                  type="textarea"
                  rows={2}
                  value={newValue}
                  onChange={(e) => this.setState({ newValue: e.target.value })}
                  placeholder="Enter rejection reason"
                />
                <p>
                  Thank you for your feedback. Someone will follow up with you
                  to confirm next steps.
                </p>
              </div>
            </div>
            <div className="position-relative  form-group">
              <label className="form-label">Document (optional)</label>
            </div>
            <FormFileUpload
              hideUploadAfterFile={true}
              onFileUploaded={(fileInfo) =>
                this.updateCustomDocument({
                  fileKey: fileInfo.key,
                  fileName: fileInfo.name,
                })
              }
              isPublic={true}
            >
              {privateDocument && privateDocument.fileName}
            </FormFileUpload>
          </form>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary" onClick={this.hide}>
            Cancel
          </button>
          <Button
            label="Reject Document"
            className="btn btn-danger"
            onClick={this.save}
            showSpinner={this.state.saving}
            disabled={this.state.saving}
          />
        </ModalFooter>
      </SimpleModal>
    );
  }
}
